import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Customer } from '@app/core/models/customer.model';

@Component({
  selector: 'app-advertiser-id-chip',
  templateUrl: './advertiser-id-chip.component.html',
  styleUrls: ['./advertiser-id-chip.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserIdChipComponent {

	@Input()
	customer : Customer | undefined;

	public getText() {
		return this.customer?.id
			+ (this.customer?.name ? ' \u2022 ' + this.customer.name : '')
			+ (this.customer?.city ? ' (' + this.customer.city + ')': '');
	}

	constructor(private _router: Router) { }

	openAdvertiser(): void {
		if (this.customer && !this.customer.agency && this.customer.id) {
			this._router.navigate(["/advertiser"], { state: { customer: this.customer } });
		}
	}

}
